import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Conversation {
  _id: string;
  participants: string[];
  participantsKey?: string;
  lastMessageAt?: string;
  createdAt: string;
  updatedAt: string;
  __v?: number;
}

export type CreateConversationPayload = {
  participantId: string;
};

export type CreateConversationResponse = {
  success: boolean;
  message: string;
  data: Conversation;
};

const createConversation = async (
  payload: CreateConversationPayload
): Promise<CreateConversationResponse> => {
  const { data } = await customAxios.post<CreateConversationResponse>(
    "/chat/conversations",
    payload
  );
  return data;
};

export const useCreateConversation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CreateConversationResponse,
    AxiosError,
    CreateConversationPayload
  >({
    mutationFn: createConversation,
    onSuccess: async (data) => {
      showNotification({
        title: "Conversation created",
        message: data.message,
        color: "green",
      });
      await queryClient.invalidateQueries({ queryKey: ["conversations"] });
    },

    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to create conversation",
        color: "red",
      }),
  });
};
